import { IMcc, IOption, IOptionCategory } from '../../interface'
import { TFunction } from 'i18next'
import { ValidationErrors } from 'final-form'

export const checkIfInputHasAnError = (
  errors: ValidationErrors,
  inputName: string,
  touched?: { [key: string]: boolean }
): boolean => {
  return touched[inputName] && Object.keys(errors).includes(inputName)
}

export const formatCategoryOptionsForCategory = (categories: []): IOption[] =>
  categories.map(({ code, id, mccs, name: label }: IOptionCategory) => ({
    id,
    label,
    mccs: sortOptionAlphabetically(formatMccOptions({ id, label, value: id }, mccs)),
    value: id,
    code
  }))

export const formatAllMCCs = (categories: []): IOption[] =>
  categories.map(({ id, mccs, name: label }: IOptionCategory) => ({
    id,
    label,
    options: sortOptionAlphabetically(formatMccOptions({ id, label, value: id }, mccs)),
    value: id
  }))

export const formatMccOptions = (category: IOption, mccs: IMcc[] = []): IOption[] =>
  mccs.map(({ code: value, description: label, ...rest }: IMcc) => ({ data: category, label, value, ...rest }))

export const sortOptionAlphabetically = (options: IOption[] = []): IOption[] =>
  options.sort(({ label: labelOptionOne }: IOption, { label: labelOptionTwo }: IOption) =>
    labelOptionOne.localeCompare(labelOptionTwo)
  )
